import { RatingDto } from "@/types/rating.type";
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

interface RatingFilter {
  startDateOnly: string;
  dtName: string;
  officeName: string;
  rating: string;
  comments: string;
}

interface RatingTableRow extends RatingDto {
  disabled: boolean;
  dtName: string;
}

@Component({
  computed: {
    ...mapState("Ratings", ["openRatings", "closedRatings"])
  },
})
export default class RatingMixin extends Vue {
  openRatings!: RatingDto[];
  closedRatings!: RatingDto[];

  fields = [
    { key: 'startDateOnly', label: 'Date', sortable: true },
    { key: 'dtName', label: 'Team Member', sortable: true },
    { key: 'officeName', label: 'Office', sortable: true },
    { key: 'rating', label: 'Shift Rating', sortable: true },
    { key: 'noShow', label: 'No Show', sortable: false, thStyle: {verticalAlign: 'top'} },
    { key: 'sickCall', label: 'Sick Call', sortable: false, thStyle: { verticalAlign: 'top' }},
    { key: 'comments', label: 'Comments', sortable: true }
  ];

  filters = {
    startDateOnly: '',
    dtName: '',
    officeName: '',
    rating: '',
    comments: ''
  } as RatingFilter;

  get filtered(): RatingTableRow[] {
    const openRatings = [...this.openRatings]
      .sort((a, b) => b.startDateOnly.toString().localeCompare(a.startDateOnly.toString()))
      .map(item => ({
        ...item,
        disabled: false,
        dtName: `${item.dtFirstName} ${item.dtLastName}`
      }));

    const closedRatings = [...this.closedRatings]
      .sort((a, b) => b.startDateOnly.toString().localeCompare(a.startDateOnly.toString()))
      .map(item => ({
        ...item,
        disabled: true,
        dtName: `${item.dtFirstName} ${item.dtLastName}`
      }));

    const filtered = [...openRatings, ...closedRatings].filter(item =>
      Object.keys(this.filters)
        .every(key =>
          String(item[key as keyof RatingTableRow] ?? "")
            .toLowerCase()
            .includes(this.filters[key as keyof RatingFilter].toString().toLowerCase())
      ));

    return filtered.length > 0 ? filtered : [];
  }
}